var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLayer = function SvgIconLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#23262F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.758 2.188 4.425 1.965c1.275.563 1.275 1.493 0 2.055L9.758 8.173c-.503.225-1.328.225-1.83 0L3.503 6.208c-1.275-.562-1.275-1.492 0-2.055l4.425-1.965c.502-.225 1.327-.225 1.83 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#23262F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.25 8.25c0 .63.473 1.357 1.05 1.613l5.093 2.264c.39.173.832.173 1.214 0L14.7 9.864c.578-.255 1.05-.983 1.05-1.613"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#23262F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.25 12c0 .697.413 1.328 1.05 1.613l5.093 2.264c.39.173.832.173 1.214 0l5.093-2.264A1.768 1.768 0 0 0 15.75 12"
  })));
};
export default SvgIconLayer;